import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable, of } from 'rxjs';

import { UserModel } from '../models/user.model';
import { TokenService } from '../token/token.service';

@Injectable({ providedIn: 'root' })
export class UserService {
  private userSubject = new BehaviorSubject<UserModel | null>(null);
  avatarSubject = new BehaviorSubject<any>(false);
  jwtHelper = new JwtHelperService();

  constructor(private tokenService: TokenService) {
    // tslint:disable-next-line: no-unused-expression
    this.tokenService.hasToken() && this.decodeAndNotify();
  }

  setToken(token: string) {
    this.tokenService.setToken(token);
    this.decodeAndNotify();
  }

  setUser(user: any) {
    this.userSubject.next(user);
  }

  getUser() {
    return this.userSubject.asObservable();
  }

  notify(user: UserModel) {
    this.userSubject.next(user);
  }

  private decodeAndNotify() {
    try {
      const token = this.jwtHelper.decodeToken(
        this.tokenService.getToken() as string
      );
      const user = JSON.parse(token.userData);
      // console.log(user);
      this.userSubject.next(user);
      this.avatarSubject.next(true);
    } catch (error) {
      this.logout();
    }
  }

  logout() {
    this.tokenService.removeToken();
    this.userSubject.next(null);
  }

  isLogged() {
    return this.tokenService.hasToken();
  }

  getUserRoles(): Observable<any> {
    const user = this.userSubject.value;

    if (user) {
      return of(user.roles);
    }

    return of([]);
  }

  hasRole(role: string): boolean {
    return true;
    // const user = this.userSubject.value;
    // return user ? user.roles.includes(role) : false;
  }

  isTokenExpired() {
    if (this.tokenService.hasToken()) {
      const token = this.tokenService.getToken();
      const isExpired = this.jwtHelper.isTokenExpired(token);

      return isExpired;
    }

    return false;
  }
}
